"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationHistoryPage = exports.InstallationHistoryQuery = exports.ConnectionHistoryPage = exports.ConnectionHistoryQuery = exports.AssignOwnerResult = exports.AssignOwnerBody = exports.DevicePatch = exports.InstallationAddressBody = exports.MetadataBody = exports.MetadataItem = exports.LoyaltyUpdate = exports.LoyaltyProgramsBody = exports.LogLevel = exports.OperatingModeAndPowerProfile = exports.SwVersion = exports.ExpressSerialQuery = exports.TenantAssociations = exports.RegistryDevice = exports.LegacyDevice = exports.RegistryQuery = exports.SerialNumberQuery = exports.UncheckedSerialQuery = exports.MsnPairs = exports.MsnPair = exports.MsnsQuery = exports.MsnQuery = exports.RegistryListPage = exports.RegistryListQuery = exports.RegistryListItem = exports.DevicePage = exports.DevicesQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../../../../../../date");
const json_1 = require("../../../../../../../../json");
const pagination_1 = require("../../../../../../../../pagination");
const Device = __importStar(require("../../../../../../../device"));
const Tenant = __importStar(require("../../../../../../../tenant"));
const User = __importStar(require("../../../../../../../user"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Admin.Device.Registry.Schema';
const deviceId = Device.Class.Common.Id;
/** Query of `GET /v2/admin/device`. */
exports.DevicesQuery = effect_1.Schema.Struct({
    page: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive()), { exact: true }),
    pageSize: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString.pipe(effect_1.Schema.int(), effect_1.Schema.positive(), effect_1.Schema.lessThanOrEqualTo(100)), { exact: true }),
    orderBy: effect_1.Schema.optionalWith(effect_1.Schema.Literal('id', 'model', 'status', 'swVersion'), { exact: true }),
    orderDir: effect_1.Schema.optionalWith(effect_1.Schema.Literal('asc', 'desc'), { exact: true }),
    tenantIds: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyArray(Tenant.Id), { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.DevicesQuery`,
    description: 'Page, sort and tenant filter. pageSize above 100 does not decode. A single tenantIds value is a string and does not decode. ' +
        'orderDir is only asc or desc; an omitted orderDir with orderBy sorts descending.',
});
/** Devices returned by `GET /v2/admin/device`, encoded through the domain device schema. */
exports.DevicePage = (0, pagination_1.paginate)(Device.Class.Device).annotations({
    identifier: `${exports.NAMESPACE}.DevicePage`,
});
const countedAlarms = effect_1.Schema.Struct({
    critical: effect_1.Schema.Number,
    nonCritical: effect_1.Schema.Number,
});
/**
 * One row of `GET /registry/list` after the legacy parser.
 * `errors` and `alarms` are removed. The remaining filtered fields stay as stored.
 */
exports.RegistryListItem = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.String,
    name: effect_1.Schema.NullOr(effect_1.Schema.String),
    brandName: effect_1.Schema.NullOr(effect_1.Schema.String),
    brandId: effect_1.Schema.NullOr(effect_1.Schema.String),
    swVersion: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(json_1.Value), { exact: true }),
    operatingMode: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(json_1.Value), { exact: true }),
    powerProfile: effect_1.Schema.NullOr(json_1.Value),
    logLevel: effect_1.Schema.NullOr(json_1.Value),
    region: effect_1.Schema.NullOr(json_1.Value),
    metaData: effect_1.Schema.NullOr(json_1.Value),
    loyaltyPrograms: effect_1.Schema.Array(effect_1.Schema.Struct({ id: effect_1.Schema.String, name: effect_1.Schema.String })),
    status: effect_1.Schema.Struct({
        errors: effect_1.Schema.Number,
        alarms: countedAlarms,
        connection: json_1.Value,
    }),
    id: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    model: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    ownerId: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    dealerId: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    tenantId: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    config: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    lat: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    lon: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    registrationToken: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    protocolVersion: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    detectedLocation: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    createdAt: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    registeredAt: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    updatedAt: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    consumables: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    alerts: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    installationAddress: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryListItem`,
    description: 'Parsed registry row. errors and alarms are deleted. Alarm counts are critical and nonCritical. ' +
        'swVersion and operatingMode are omitted when properties exists without that field.',
});
/** Query of `GET /registry/list`. `size` is accepted by validation and then ignored. */
exports.RegistryListQuery = effect_1.Schema.Struct({
    page: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    size: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    pageSize: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    orderBy: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    orderDir: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryListQuery`,
    description: 'pageSize must be from 1 to 100. A value outside that range is 422. size is validated and ignored. An omitted pageSize uses 50. ' +
        'orderBy is any string, and a comma-separated list sorts by each field.',
});
exports.RegistryListPage = effect_1.Schema.Struct({
    itemsCount: effect_1.Schema.Number,
    pagesCount: effect_1.Schema.Number,
    page: effect_1.Schema.Number,
    items: effect_1.Schema.Array(exports.RegistryListItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryListPage`,
});
/** Query of `GET /dsn`. */
exports.MsnQuery = effect_1.Schema.Struct({
    manufacturingSerialNumber: effect_1.Schema.String,
}).annotations({
    identifier: `${exports.NAMESPACE}.MsnQuery`,
});
/** Query of `GET /dsns`. The field is `manufacturingSerialNumbers`, not the singular name. */
exports.MsnsQuery = effect_1.Schema.Struct({
    manufacturingSerialNumbers: effect_1.Schema.Array(effect_1.Schema.String),
}).annotations({
    identifier: `${exports.NAMESPACE}.MsnsQuery`,
    description: 'manufacturingSerialNumbers is the query field. A single string does not decode.',
});
exports.MsnPair = effect_1.Schema.Struct({
    manufacturingSerialNumber: effect_1.Schema.NullOr(effect_1.Schema.String),
    deviceSerialNumber: deviceId,
}).annotations({
    identifier: `${exports.NAMESPACE}.MsnPair`,
});
exports.MsnPairs = effect_1.Schema.Array(exports.MsnPair).annotations({
    identifier: `${exports.NAMESPACE}.MsnPairs`,
});
/** Query serial the loyalty update reads and does not validate. */
exports.UncheckedSerialQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.UncheckedSerialQuery`,
    description: 'Not validated. A value that loads no device is 404.',
});
/** Query shared by the registry reads that decode a device id. */
exports.SerialNumberQuery = effect_1.Schema.Struct({
    serialNumber: deviceId,
}).annotations({
    identifier: `${exports.NAMESPACE}.SerialNumberQuery`,
});
/** Query of `GET /registry`. `domainOutput` is read by the router, not by the decoder. */
exports.RegistryQuery = effect_1.Schema.Struct({
    serialNumber: deviceId,
    domainOutput: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.RegistryQuery`,
    description: 'An absent domainOutput, an empty string, or the string false selects the legacy device. Any other value selects the domain device.',
});
const legacyAlarm = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    time: json_1.Value,
    alarm: effect_1.Schema.Struct({
        id: effect_1.Schema.String,
        name: effect_1.Schema.NullOr(effect_1.Schema.String),
        description: effect_1.Schema.NullOr(effect_1.Schema.String),
        severity: effect_1.Schema.NullOr(effect_1.Schema.String),
    }),
});
const legacyConsumable = effect_1.Schema.Struct({
    consumable: effect_1.Schema.Struct({
        id: effect_1.Schema.NullOr(effect_1.Schema.String),
        name: effect_1.Schema.NullOr(effect_1.Schema.String),
        description: effect_1.Schema.NullOr(effect_1.Schema.String),
        kind: effect_1.Schema.Null,
    }),
    index: effect_1.Schema.Number,
    subset: effect_1.Schema.Struct({
        id: effect_1.Schema.NullOr(effect_1.Schema.String),
        name: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
        description: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), { exact: true }),
        rangeExhaust: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
        rangeTrigger: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
        rangeFullCapacity: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
        lifespan: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    }),
    current: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
    expiresAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    installedAt: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.Number), { exact: true }),
    batch: effect_1.Schema.optionalWith(json_1.Value, { exact: true }),
});
/** Body of the legacy `GET /registry` path. */
exports.LegacyDevice = effect_1.Schema.Struct({
    id: deviceId,
    model: effect_1.Schema.String,
    ownerId: effect_1.Schema.NullOr(effect_1.Schema.String),
    protocolVersion: effect_1.Schema.Number,
    registrationToken: effect_1.Schema.Null,
    createdAt: json_1.Value,
    updatedAt: json_1.Value,
    registeredAt: effect_1.Schema.NullOr(json_1.Value),
    lat: effect_1.Schema.NullOr(effect_1.Schema.Number),
    lon: effect_1.Schema.NullOr(effect_1.Schema.Number),
    dealerId: effect_1.Schema.NullOr(effect_1.Schema.String),
    swVersion: effect_1.Schema.NullOr(effect_1.Schema.String),
    status: effect_1.Schema.Struct({
        errors: effect_1.Schema.Number,
        alarms: effect_1.Schema.Struct({
            critical: effect_1.Schema.Number,
            nonCritical: effect_1.Schema.Number,
        }),
        connection: effect_1.Schema.Struct({
            online: effect_1.Schema.Boolean,
            lastUpdate: effect_1.Schema.NullOr(json_1.Value),
            hub: effect_1.Schema.NullOr(effect_1.Schema.String),
        }),
    }),
    alarms: effect_1.Schema.Array(legacyAlarm),
    errors: effect_1.Schema.Array(json_1.Value),
    config: effect_1.Schema.Struct({}),
    consumables: effect_1.Schema.Array(legacyConsumable),
    tenantId: effect_1.Schema.NullOr(effect_1.Schema.String),
    name: effect_1.Schema.NullOr(effect_1.Schema.String),
    serialNumber: deviceId,
    operatingMode: effect_1.Schema.NullOr(json_1.Value),
    powerProfile: effect_1.Schema.NullOr(json_1.Value),
    logLevel: effect_1.Schema.NullOr(json_1.Value),
    iccid: effect_1.Schema.NullOr(effect_1.Schema.String),
    region: effect_1.Schema.Struct({
        code: effect_1.Schema.NullOr(effect_1.Schema.String),
        name: effect_1.Schema.NullOr(effect_1.Schema.String),
    }),
    metaData: json_1.Value,
    loyaltyPrograms: effect_1.Schema.Array(effect_1.Schema.String),
    installationAddress: effect_1.Schema.NullOr(json_1.Value),
    description: effect_1.Schema.Null,
    connectivity: effect_1.Schema.NullOr(effect_1.Schema.Array(Device.Class.Base.Connectivity)),
    image: effect_1.Schema.NullOr(effect_1.Schema.String),
    supportedOperatingModes: effect_1.Schema.Array(effect_1.Schema.String),
    supportedPowerProfiles: effect_1.Schema.Array(effect_1.Schema.String),
    telemetry: effect_1.Schema.Struct({
        lastUpdate: effect_1.Schema.NullOr(effect_1.Schema.Number),
        telemetries: effect_1.Schema.Array(effect_1.Schema.Struct({
            id: effect_1.Schema.String,
            name: effect_1.Schema.NullOr(effect_1.Schema.String),
            description: effect_1.Schema.NullOr(effect_1.Schema.String),
            primitive: effect_1.Schema.NullOr(effect_1.Schema.String),
            unitOfMeasure: effect_1.Schema.NullOr(effect_1.Schema.String),
            value: json_1.Value,
            expectedValue: effect_1.Schema.NullOr(json_1.Value),
            min: effect_1.Schema.NullOr(json_1.Value),
            max: effect_1.Schema.NullOr(json_1.Value),
            tags: effect_1.Schema.Array(effect_1.Schema.String),
        })),
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.LegacyDevice`,
    description: 'Legacy registry device. registrationToken and description are always null. ' +
        'brandName and brandId are not returned: the handler reads vendor.Name and vendor.Code, which are schemas, so JSON omits them.',
});
/** Either device `GET /registry` can return. `null` is the domain path with no caller tenant. */
exports.RegistryDevice = effect_1.Schema.NullOr(effect_1.Schema.Union(Device.Class.Device, exports.LegacyDevice)).annotations({
    identifier: `${exports.NAMESPACE}.RegistryDevice`,
});
exports.TenantAssociations = effect_1.Schema.Struct({
    tenantAssociations: effect_1.Schema.Array(effect_1.Schema.Struct({
        countryCode: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
        modelCode: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    })),
}).annotations({
    identifier: `${exports.NAMESPACE}.TenantAssociations`,
    description: 'Associations with the unset fields removed. An empty array is a successful response.',
});
/** express-validator serial query. Any non-empty string is accepted; it is not checked as a device id. */
exports.ExpressSerialQuery = effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.NonEmptyString,
}).annotations({
    identifier: `${exports.NAMESPACE}.ExpressSerialQuery`,
});
exports.SwVersion = effect_1.Schema.Struct({
    swVersion: effect_1.Schema.String,
}).annotations({ identifier: `${exports.NAMESPACE}.SwVersion` });
exports.OperatingModeAndPowerProfile = effect_1.Schema.Struct({
    operatingMode: effect_1.Schema.NullOr(json_1.Value),
    powerProfile: effect_1.Schema.NullOr(json_1.Value),
}).annotations({
    identifier: `${exports.NAMESPACE}.OperatingModeAndPowerProfile`,
});
exports.LogLevel = effect_1.Schema.Struct({
    logLevel: json_1.Value,
}).annotations({ identifier: `${exports.NAMESPACE}.LogLevel` });
exports.LoyaltyProgramsBody = effect_1.Schema.Struct({
    loyaltyPrograms: effect_1.Schema.Array(effect_1.Schema.NonEmptyString),
}).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyProgramsBody`,
});
exports.LoyaltyUpdate = effect_1.Schema.Struct({
    success: effect_1.Schema.Literal(true),
}).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyUpdate`,
    description: 'data.success is true. The envelope is the v1 success body.',
});
exports.MetadataItem = effect_1.Schema.Struct({
    key: effect_1.Schema.NonEmptyString,
    value: json_1.Value,
}).annotations({ identifier: `${exports.NAMESPACE}.MetadataItem` });
exports.MetadataBody = effect_1.Schema.Struct({
    items: effect_1.Schema.NonEmptyArray(exports.MetadataItem),
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.MetadataBody`,
});
const InstallationAddressFields = Device.Class.Base.CommonProps.fields.installationAddress
    .pick('addressExtra', 'countryCode', 'state')
    .pipe(effect_1.Schema.extend(effect_1.Schema.Struct({
    address: effect_1.Schema.NonEmptyString,
    zip: effect_1.Schema.NonEmptyString,
    city: effect_1.Schema.NonEmptyString,
    country: effect_1.Schema.NonEmptyString,
})));
/** Body of `PUT /registry/installation-address`. */
exports.InstallationAddressBody = effect_1.Schema.extend(effect_1.Schema.Struct({ installationAddress: InstallationAddressFields }), Device.Class.Base.CommonProps.pick('providedLocation').pipe(effect_1.Schema.partialWith({ exact: true }))).annotations({
    identifier: `${exports.NAMESPACE}.InstallationAddressBody`,
});
const UpdatableCommonProps = Device.Class.Base.CommonProps.pipe(effect_1.Schema.omit('id', 'connectionStatus', 'lastTelemetryUpdate', 'lastAlarmTime', 'lastConsumablesUpdate', 'lastEventTime', 'lastErrorTime', 'lastStateUpdate', 'createdAt', 'updatedAt', 'detectedLocation', 'installedAt', 'registeredAt', 'deregisteredAt', 'ownerId', 'lastConfigUpdate', 'dataRegions', 'swVersion', 'hwVersion', 'errors', 'protocolVersion', 'ring'));
const Vendor = effect_1.Schema.Struct({
    vendor: effect_1.Schema.encodedSchema(Device.Vendor.DeviceInfo),
});
/** Body of `PATCH /registry/{deviceId}`. `ownerId` is read and then removed before the patch decode. */
exports.DevicePatch = effect_1.Schema.extend(effect_1.Schema.partialWith(effect_1.Schema.encodedSchema(UpdatableCommonProps).pipe(effect_1.Schema.extend(effect_1.Schema.encodedSchema(Vendor))), {
    exact: true,
}), effect_1.Schema.Struct({
    ownerId: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(User.Id), { exact: true }),
})).annotations({
    identifier: `${exports.NAMESPACE}.DevicePatch`,
    description: 'Partial encoded device fields the patch accepts. ownerId may be sent: the stored value is ignored, and a different value is rejected. Any other unknown field is rejected.',
});
exports.AssignOwnerBody = effect_1.Schema.Struct({
    userId: User.Id,
    expectedCurrentOwnerId: effect_1.Schema.NullOr(User.Id),
}).annotations({
    identifier: `${exports.NAMESPACE}.AssignOwnerBody`,
    description: 'expectedCurrentOwnerId is required and may be null.',
});
exports.AssignOwnerResult = effect_1.Schema.Struct({
    changed: effect_1.Schema.Boolean,
    device: Device.Class.Device,
}).annotations({
    identifier: `${exports.NAMESPACE}.AssignOwnerResult`,
    description: 'changed is false when the device is already owned by userId.',
});
/** Query of connection history. Both bounds are required numeric strings. */
exports.ConnectionHistoryQuery = effect_1.Schema.Struct({
    connectionStart: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.compose(date_1.Timestamp)),
    connectionEnd: effect_1.Schema.NumberFromString.pipe(effect_1.Schema.compose(date_1.Timestamp)),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionHistoryQuery`,
});
exports.ConnectionHistoryPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(Device.History.ConnectionHistoryEvent),
}).annotations({
    identifier: `${exports.NAMESPACE}.ConnectionHistoryPage`,
});
/** Query of installation-status history. `from` and `to` are optional numeric strings. */
exports.InstallationHistoryQuery = effect_1.Schema.Struct({
    from: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString, { exact: true }),
    to: effect_1.Schema.optionalWith(effect_1.Schema.NumberFromString, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.InstallationHistoryQuery`,
    description: 'A from or to of 0 is decoded and then ignored, because the handler tests the number as truthy.',
});
exports.InstallationHistoryPage = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(Device.History.InstallationUpdate),
}).annotations({
    identifier: `${exports.NAMESPACE}.InstallationHistoryPage`,
    description: 'The handler returns the stored rows.',
});
//# sourceMappingURL=schema.js.map